import _ from 'underscore';
import Content from '../../content.js';

const GLOBAL_OPTION = 'global';

var RoleForm = Content.extend({
  dom: {
    CAPABILITY_CHECKBOX: '.capability-box ul input',
    COLUMN_CHECKBOX_TOGGLE: '.column-checkbox-toggle',
    CUSTOMER_DROPDOWN: '#customer-selector',
    EDITABLE_PROPERTIES_INPUT: '#role_editable_properties',
    FORM_SELECTOR: '.io-form',
    INPUT_SUBMIT: 'button.submit',
    PROPERTY_CHECKBOX: 'input[name^="[editable_properties]"]',
    SELECT_SECTION: '.select-all',
  },

  editable_properties: {
    node_property_ids: [],
    node_group_property_ids: [],
  },

  editable_properties_input: null,

  events: function () {
    const events = {};

    events['change ' + this.dom.SELECT_SECTION] = '_toggleSection';
    events['change ' + this.dom.CAPABILITY_CHECKBOX] =
      '_toggleCapabilityCheckbox';
    events['change ' + this.dom.COLUMN_CHECKBOX_TOGGLE] =
      '_toggleColumnSelectAllCheckboxes';
    events['change ' + this.dom.PROPERTY_CHECKBOX] =
      '_toggleDisabledAndSelectAllStates';
    events['change ' + this.dom.PROPERTY_CHECKBOX] =
      '_updateEditablePropertiesInput';

    return events;
  },

  render: function () {
    this._toggleSubmit();
    this.editable_properties_input = document.querySelector(
      this.dom.EDITABLE_PROPERTIES_INPUT,
    );
    this.editable_properties = JSON.parse(this.editable_properties_input.value);

    $(this.dom.CUSTOMER_DROPDOWN).on(
      'select2:select',
      this._enforceGlobalExclusivity.bind(this),
    );

    document.body.addEventListener(
      'htmx:load',
      function () {
        $(this.dom.PROPERTY_CHECKBOX).on(
          'change',
          this._toggleDisabledAndSelectAllStates.bind(this),
        );
        this._setCheckedProperties();
        this._toggleDisabledAndSelectAllStates();
      }.bind(this),
    );
  },

  _toggleSubmit: function () {
    const hasAtLeastOneCapabilityOrPropertyChecked =
      $('.capability-box ul input[type="checkbox"]:checked').length > 0 ||
      $('input[name^="[editable_properties]"]:checked').length > 0;

    $(this.dom.INPUT_SUBMIT).attr(
      'disabled',
      !hasAtLeastOneCapabilityOrPropertyChecked,
    );
  },

  _enforceGlobalExclusivity: function (e) {
    const $dropdown = $(this.dom.CUSTOMER_DROPDOWN);
    const selectedId = e.params.data.id;
    let values = $dropdown.val() || [];

    if (selectedId === GLOBAL_OPTION) {
      values = [GLOBAL_OPTION];
    } else {
      const globalIndex = values.indexOf(GLOBAL_OPTION);
      if (globalIndex !== -1) {
        // unselect global option
        values.splice(globalIndex, 1);
      }
    }

    $dropdown.val(values).trigger('change');
  },

  _toggleSection: function (e) {
    const child = $(e.target)
      .parents('.capability-box')
      .find('ul')
      .find('input');

    child.prop('checked', $(e.target).is(':checked'));
    this._toggleSubmit();
  },

  _updateEditablePropertiesInput: function (e) {
    const property = e.target;
    const parsedPropertyValue = parseInt(property.value);

    // "node_property_ids" or "node_group_property_ids"
    const key = property.name.match(/\[editable_properties\]\[(.+?)\]\[\]/)[1];
    const targetProperties = this.editable_properties[key] || [];

    if (e.target.checked) {
      if (!_.contains(targetProperties, parsedPropertyValue)) {
        this.editable_properties[key] = targetProperties.concat([
          parseInt(parsedPropertyValue),
        ]);
      }
    } else {
      this.editable_properties[key] = _.without(
        targetProperties,
        parsedPropertyValue,
      );
    }

    this.editable_properties_input.value = JSON.stringify(
      this.editable_properties,
    );

    this._toggleSubmit();
  },

  _setCheckedProperties: function () {
    Object.keys(this.editable_properties).forEach((key) => {
      const propertiesFromGroup = this.editable_properties[key];

      propertiesFromGroup.forEach((value) => {
        if (propertiesFromGroup.includes(value)) {
          $(
            `input[name="[editable_properties][${key}][]"][value="${value}"]`,
          ).prop('checked', true);
        }
      });
    });
  },

  _toggleDisabledAndSelectAllStates: function () {
    const isFormOnDisabledState = $('input[name^="role"]')
      .first()
      .prop('disabled');

    $(this.dom.COLUMN_CHECKBOX_TOGGLE).each((_index, element) => {
      const target = $(element).data('target');
      const checkboxes = $(
        `input[name="[editable_properties][${target}][]"]`,
      ).prop('disabled', isFormOnDisabledState);
      const checkedCheckboxes = checkboxes.filter(':checked');

      $(element)
        .prop(
          'checked',
          checkboxes.length > 0 &&
            checkboxes.length === checkedCheckboxes.length,
        )
        .prop('disabled', isFormOnDisabledState);
    });
  },

  _toggleCapabilityCheckbox: function (e) {
    const parent = $(e.target)
        .parents('.capability-box')
        .find('.select-all input'),
      children = $(e.target).parents('.capability-box').find('ul input'),
      childrenChecked = children.filter(':checked');

    parent.prop('checked', children.length === childrenChecked.length);
    this._toggleSubmit();
  },

  _toggleColumnSelectAllCheckboxes: function (e) {
    const target = $(e.target).data('target');
    const checkboxes = $(`input[name="[editable_properties][${target}][]"]`);

    checkboxes.prop('checked', $(e.target).is(':checked')).trigger('change');
  },
});

module.exports = RoleForm;
